import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SvgStore } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-svg",
  templateUrl: "svg.component.html",
  standalone: false,
})
export class SvgComponent implements OnChanges {
  @Input() id!: string;
  @Input() brand!: string;
  @Input() width: number | string = 24;
  @Input() height: number | string = 24;
  @Input() fill = "#000";
  @Input() class = "svg-neutral";

  public svgContent: SafeHtml = "";
  public viewBox = "0 0 24 24";

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges() {
    const def = this.id && SvgStore[this.id];
    if (def) {
      this.svgContent = this.sanitizer.bypassSecurityTrustHtml(def.html);
      this.viewBox = def.viewBox;
    }
  }
}
